import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import DashboardLayout from '../layouts/DashboardLayout.vue'
import InsightsView from '../views/InsightsView.vue'
import LoginView from '../views/LoginView.vue'
import { authGuard, createAuthGuard, useAuth0 } from '@auth0/auth0-vue'
import TransactionView from '../views/TransactionView.vue'
import DatasetsView from '@/views/DatasetsView.vue'
import CustomersView from '@/views/CustomersView.vue'
import IntelligenceView from '@/views/IntelligenceView.vue'
import SettingsView from '@/views/SettingsView.vue'
import UsersView from '@/views/UsersView.vue'
import NotFoundView from '@/views/NotFoundView.vue'


const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardLayout,
    beforeEnter: authGuard,
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: InsightsView
      },
      {
        path: "transactions",
        name: "Transactions",
        component: TransactionView
      },
      {
        path: "datasets",
        name: "Datasets",
        component: DatasetsView
      },
      {
        path: "customers",
        name: "Customers",
        component: CustomersView
      },
      {
        path: "intelligence",
        name: "Intelligence",
        component: IntelligenceView
      },
      {
        path: "settings",
        name: "Settings",
        component: SettingsView
      },
      {
        path: "users",
        name: "Users",
        component: UsersView
      },

    ]
  },
  {
    path: "/:pathMatch(.*)*",
    component: NotFoundView
  }
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to: any, from: any, savedPosition: any) {
    return { top: 0, left: 0, behavior: 'smooth' }
  }
})

export default router
